import { moduleFile } from "@lib/appconst"
import fileService from "@services/common/fileService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import unitDesignService from "@services/master-data/unitDesignService"
import { action, makeAutoObservable, observable } from "mobx"
import { appDataStoreInstance as appDataStore } from "../appDataStore"

class UnitDesignStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any

  constructor() {
    makeAutoObservable(this)
    this.tableData = { items: [], totalCount: 0 }
  }

  @action
  async createOrUpdate(body: any, files?: any) {
    const result = await unitDesignService.createOrUpdate(body)
    this.detailData = result
    const { uniqueId } = result
    if (files && files.length && uniqueId) {
      files.forEach(async (file) => {
        if (file.originFileObj !== undefined) {
          const fileUpload = file.originFileObj
          await fileService.upload(moduleFile.unitDesign, uniqueId, fileUpload)
        }
      })
      this.isLoading = false
    }

    if (!body.id) {
      this.tableData.items.push(result)
    } else {
      this.tableData.items = this.tableData.items.map((x) => {
        if (x.id === body.id) x = result
        return x
      })
    }
    appDataStore.GetListUnitDesign()
  }

  @action
  async newUnitDesign() {
    this.detailData = {
      id: 0,
    }
  }

  @action
  async active(id: number, isActive) {
    await unitDesignService.activate(id, isActive)
    appDataStore.GetListUnitDesign()
  }

  @action
  async get(id: number) {
    const result = await unitDesignService.get(id)
    this.detailData = result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await unitDesignService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }
}

export default UnitDesignStore
